import React from 'react';
import { motion } from 'framer-motion';
interface MicroImpactBlockProps {
  text: string;
  theme?: 'dark' | 'light';
}
export function MicroImpactBlock({
  text,
  theme = 'dark'
}: MicroImpactBlockProps) {
  const isDark = theme === 'dark';
  return;
}